import { Modal } from "antd";
import { FC } from "react";
import { FacingFinGroup } from "tm-shared/types";

import { useAppSelector } from "@/hooks/redux";
import { PrimaryText } from "@/shared/ui/Typography";

import { CheckboxFinGroupRow } from "./CheckboxFinGroupRow";
import {
    StyledContentBody,
    StyledContentList,
    StyledContentListContainer,
} from "./Styled";

interface AddFinGroupModalProps {
    open: boolean;
    onClose: () => void;
    selectedFinGroups: FacingFinGroup[];
    onAdd: (finGroup: FacingFinGroup) => void;
    onRemove: (finGroup: string) => void;
}

export const AddFinGroupModal: FC<AddFinGroupModalProps> = ({
    onClose,
    open,
    selectedFinGroups,
    onAdd,
    onRemove,
}) => {
    const finGroupOptions = useAppSelector((s) => s.work.options.finGroups);

    const isFinGroupSelected = (finGroup: string) => {
        return selectedFinGroups.some((f) => finGroup === f.finGroup);
    };

    const handleCheckboxChange = (
        finGroup: FacingFinGroup,
        checked: boolean,
    ) => {
        if (checked) {
            onAdd(finGroup);
        } else {
            onRemove(finGroup.finGroup);
        }
    };

    return (
        <Modal
            title={"Додати фінансову групу"}
            open={open}
            onCancel={onClose}
            centered={true}
            footer={[]}
            mask={{ closable: false }}
            styles={{ body: { height: "90vh" }, footer: { margin: 0 } }}
        >
            <StyledContentBody>
                <StyledContentListContainer>
                    {finGroupOptions.length > 0 ? (
                        <StyledContentList vertical gap={16}>
                            {finGroupOptions.map((finGroup) => {
                                const isChecked = isFinGroupSelected(
                                    finGroup.value,
                                );

                                return (
                                    <CheckboxFinGroupRow
                                        key={finGroup.value}
                                        checked={isChecked}
                                        finGroup={finGroup}
                                        onChange={handleCheckboxChange}
                                    />
                                );
                            })}
                        </StyledContentList>
                    ) : (
                        <PrimaryText>Товарів не знайдено</PrimaryText>
                    )}
                </StyledContentListContainer>
            </StyledContentBody>
        </Modal>
    );
};
